import React from 'react';

const WhyChooseSection: React.FC = () => {
  const reasons = [
    {
      icon: 'ri-award-line',
      title: 'ICF Akreditasyonu',
      description: 'Uluslararası Koçluk Federasyonu standartlarına uygun, sertifikalı koçluk hizmetleri.',
      stats: 'Dünya Standardı'
    },
    {
      icon: 'ri-time-line',
      title: '25+ Yıl Deneyim',
      description: 'Türkiye\'nin önde gelen okullarında fizik öğretmenliği ve eğitim danışmanlığı deneyimi.',
      stats: '25+ Yıl'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Bilimsel Yaklaşım',
      description: 'Katı Hal Fiziği yüksek lisans eğitimi ile analitik düşünce ve sistematik metodoloji.',
      stats: 'MSc Fizik'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Kişiselleştirilmiş Yaklaşım',
      description: 'Her bireyin benzersizliğini göz önünde bulundurarak özelleştirilmiş koçluk programları.',
      stats: '500+ Başarı'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Etik Standartlar',
      description: 'ICF etik kurallarına tam uyum, gizlilik ve profesyonellik garantisi.',
      stats: '100% Güvenilir'
    },
    {
      icon: 'ri-global-line',
      title: 'Sürekli Gelişim',
      description: 'emcekare.xyz platformu ile sürekli eğitim ve güncel koçluk metodolojileri.',
      stats: 'Sürekli Güncel'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 via-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Neden <span className="text-teal-600">Esin Arifoğlu</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bilimsel altyapı, uluslararası standartlar ve 25+ yıllık deneyimle 
            size en kaliteli koçluk hizmetini sunuyorum.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${reason.icon} text-white text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-900">{reason.title}</h3>
                    <span className="text-sm font-semibold text-teal-600 bg-teal-100 px-3 py-1 rounded-full">
                      {reason.stats}
                    </span>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{reason.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Üç Boyut Eğitim Danışmanlık
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Profesyonel koçluk hizmetlerimi Üç Boyut Eğitim Danışmanlık bünyesinde sunuyorum. 
                Kurumsal deneyim ve bireysel yaklaşımı harmanlayarak size en iyi hizmeti veriyorum.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-teal-50 rounded-xl">
                  <div className="text-2xl font-bold text-teal-600">500+</div>
                  <div className="text-sm text-gray-600">Başarılı Koçluk</div>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-xl">
                  <div className="text-2xl font-bold text-blue-600">25+</div>
                  <div className="text-sm text-gray-600">Yıl Deneyim</div>
                </div>
                <div className="text-center p-4 bg-purple-50 rounded-xl">
                  <div className="text-2xl font-bold text-purple-600">ICF</div>
                  <div className="text-sm text-gray-600">Akreditasyon</div>
                </div>
                <div className="text-center p-4 bg-green-50 rounded-xl">
                  <div className="text-2xl font-bold text-green-600">100%</div>
                  <div className="text-sm text-gray-600">Memnuniyet</div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/17670283a8ca643f90476f55f1d3a50f.jpg"
                alt="Üç Boyut Eğitim Danışmanlık - Profesyonel koçluk ofisi"
                className="rounded-xl shadow-lg w-full h-80 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;